var $ = require('jquery');
var premiumDialog = require('./premiumDialog');

diy.angular.registerFactory('diyfmsourcebigstock', [
    '$q',
    '$injector',
    '$http',
    '$sce',
    'diyl10n',
    'diyfeatures',
    'diyfmmessages',
    'diyinfo',
    'diywebsiteid',
    'diyfmfileitemmodel',
    'diyglobalevents',
    'diyfmconfig',
    'diyfmconstbigstock',
    'diyfmtracking',
function(
    $q,
    $injector,
    $http,
    $sce,
    diyl10n,
    diyfeatures,
    diyfmmessages,
    diyinfo,
    diywebsiteid,
    diyfmfileitemmodel,
    diyglobalevents,
    diyfmconfig,
    diyfmconstbigstock,
    diyfmtracking
) {
    var
        source = {},
        itemsProvider = {},
        sourceServiceUrl = null,
        MAX_TOTAL_ITEMS_NO_SEARCH = 1000,
        MAX_TOTAL_ITEMS = 10000
    ;

    var getName = function() {
        return 'bigstock';
    };

    var getSectionModel = function() {
        return $injector.get('diyfmsectionbigstock');
    };

    var isAvailable = function() {
        return diyfeatures('bigstock');
    };

    var getSourceServiceUrl = function (fromServer) {
        var defer = $q.defer();

        if (sourceServiceUrl && !fromServer) {
            defer.resolve(sourceServiceUrl);
        } else {
            $http.get('/app/cms/js/bigstock-access').then(function(response){
                if (response.data && response.data.success) {
                    var data = response.data.data;
                    var url = data.apiUrl + 'oauth2/search/?access_token=' + data.token;
                    // caching url
                    sourceServiceUrl = url;
                    defer.resolve(sourceServiceUrl);
                } else {
                    diyfmmessages.handleGenericError();
                    defer.reject();
                }
            }, function(){
                diyfmmessages.handleGenericError();
                defer.reject();
            });
        }
        return defer.promise;
    };

    var getLanguage = function () {
        return diyinfo.getLanguage().substr(0, 2);
    };

    itemsProvider.queryRange = function(params, offset, limit) {
        params = params || {};
        var defer = $q.defer(), textSearch;

        if (isAvailable()) {
            var pathParams = '';

            // extract filters //
            textSearch = params.hasOwnProperty('search') ? params.search : '';

            // compose path params //
            pathParams += '&response_detail=all';
            pathParams += '&vectors=n';
            pathParams += '&language=' + encodeURIComponent(getLanguage());
            // TODO maybe when no search is there search with a default keyword specific to customer topic
            //if (textSearch) {
                pathParams += '&q=' + encodeURIComponent(textSearch);
            //}

            // find the smallest limit for fixed pagination that bigstock supports
            var bLimit = limit;
            while (offset % bLimit + limit > bLimit) {
                bLimit++;
            }
            pathParams += '&limit=' + bLimit;
            var pageNumber = Math.floor(offset / bLimit);
            pathParams += '&page=' + (pageNumber + 1);
            var bOffset = bLimit * pageNumber ;

            pathParams += '&callback=JSON_CALLBACK';

            getSourceServiceUrl().then(function(serviceUrl){
                $http.jsonp(serviceUrl + pathParams).then(function (response) {
                    try {
                        var data = response.data.data, images = data.images, length = images.length, convertedImages = [];

                        var start = offset - bOffset, end = Math.min(length, start + limit);

                        for (var i = start; i < end; i++) {
                            convertedImages.push({
                                id: images[i].id,
                                size: getLargestSizeCode(images[i].formats),
                                thumb: images[i].small_thumb.url,
                                file: null,
                                preview: images[i].preview.url
                            });
                        }

                        var maxTotal = textSearch === '' ? MAX_TOTAL_ITEMS_NO_SEARCH : MAX_TOTAL_ITEMS;

                        defer.resolve({
                            items: convertedImages,
                            totalCount: Math.min(data.paging.total_items, maxTotal - maxTotal % bLimit)
                        });
                    } catch (err) {
                        diyfmmessages.handleGenericError();
                        defer.reject();
                    }
                }, function (response) {
                    // XXX on zero results Bigstock API returns an 503 HTTP status code
                    // We cannot read response body this when using JSONP so we suppose we are not in this case
                    defer.resolve({
                        items: [],
                        totalCount: 0
                    });
                    //diyfmmessages.handleGenericError();
                    //defer.reject();
                });
            });
        } else {
            // set empty items
            defer.resolve({items: [], totalCount: 0});
        }

        return defer.promise;
    };

    var getItemsProvider = function() {
        return itemsProvider;
    };

    var bigstockSelectedImages = 0;
    var maxNumberOfImages, purchasedImages, availableImages, availableSizes;
    var premiumPayload;

    var toolbarItems = [];
    if (isAvailable()) {
        premiumPayload = diyfeatures.getPayload('premiumImages');
        availableSizes = diyfeatures.getPayload('bigstock').availableSizes;
        maxNumberOfImages = premiumPayload.maxImages;
        purchasedImages = premiumPayload.purchasedImages;
        if (purchasedImages === false) {
            // there was an error retrieving purchasedImages so defensively assume limit is reached
            // and populate make a dummy array of maxNumberOfImages length
            purchasedImages = maxNumberOfImages;
        }
        availableImages = diyfeatures.getPayload('bigstock').availableImages;
        toolbarItems = [
            function () {
                var obj = {
                    used : '<strong>' + purchasedImages + '</strong>',
                    total : '<strong>' + maxNumberOfImages + '</strong>'
                };
                return '<div>' + diyl10n('filemanager.bigstockSection.remainingMessage').format(obj) + '</div>';
            },
            ' ', // spacer
            'search'
        ];
    }

    var getLargestSizeCode = function(formats) {
        var largest = formats[0];
        for (var i = 1; i < formats.length; i++) {
            if (availableSizes.indexOf(largest.size_code) < availableSizes.indexOf(formats[i].size_code)) {
                largest = formats[i];
            }
        }
        return largest.size_code;
    };

    var getToolbarItems = function(subsection) {
        return toolbarItems;
    };

    var beforeInsert = function(batch) {
        var defer = $q.defer();
        var bigstockRes = batch[0].getResource();
        $.ajax({
            type: 'POST',
            url: '/app/cms/js/bigstock-to-storage',
            data: {
                id: bigstockRes.id,
                size: bigstockRes.size
            },
            success: function(response, status, jqXHR) {
                if (response.success) {
                    // add image id to the list of purchased images, in case it isn't there yet
                    if (availableImages.indexOf(bigstockRes.id) === -1) {
                        availableImages.push(bigstockRes.id);
                        premiumPayload.purchasedImages++;
                    }

                    $http.get('/rest/websites/' + diywebsiteid + '/storage-files/' + response.data.storageFileId).then(function(response){
                        var fileItem = new diyfmfileitemmodel(response.data);

                        diyglobalevents.trigger('diy-editor-filemanager-addedFiles');
                        defer.resolve([fileItem]);
                    }, function() {
                        diyfmmessages.handleGenericError();
                        defer.reject();
                    });
                } else {
                    diyfmmessages.handleGenericError();
                    defer.reject();
                }
            },
            error: function(jqXHR, status, errorThrown) {
                diyfmmessages.handleGenericError();
                defer.reject();
            }
        });

        return defer.promise;
    };

    var limitDialogOpen = false;

    var canAddToInsert = function (item) {
        if (availableImages.indexOf(item.getId()) !== -1) {
            return true;
        }

        if (diyfmconfig.getMaxSelection() === 1) {
            bigstockSelectedImages = 0;
        }

        if (bigstockSelectedImages + purchasedImages >= maxNumberOfImages) {
            //SHOW dialog
            var btnAction = function() {
                // link to Bigstock website
                window.open('http://www.bigstockphoto.com/'+ getLanguage() +'/image-'+ item.getId());
                premiumDialog.closeDialog();
                limitDialogOpen = false;
                diyfmtracking.track('jumpToBigstock');
            };
            var btnCancelAction = function() {
                premiumDialog.closeDialog();
                limitDialogOpen = false;
                diyfmtracking.track('cancelJumpToBigstock');
            };
            // preload image
            var img = new Image();

            img.src = item.getPreview();
            var showDialog = function () {
                if (limitDialogOpen) return;
                limitDialogOpen = true;
                premiumDialog.showLimitDialog(btnAction, btnCancelAction, maxNumberOfImages, item.getPreview());
                diyfmtracking.track('bigstockLimit');
            }
            if (img.complete) {
                showDialog();
            } else {
                img.onload = showDialog;
                img.onerror = showDialog;
            }
            return false;
        } else {
            bigstockSelectedImages++;
            return true;
        }
    }

    var itemRemovedFromInsert = function (item) {
        if (availableImages.indexOf(item.getId()) !== -1) {
            return true;
        }
        bigstockSelectedImages--;
    }

    var beforeSubsectionShow = function (subsection) {
        if (subsection.getId() === diyfmconstbigstock  && window.localStorage) {
            var bigstockMessageUnderstood = 'bigstockMessageUnderstood' + diywebsiteid;
            var localData = JSON.parse(window.localStorage.getItem(bigstockMessageUnderstood));
            if (!localData) {
                // show dialog
                var btnAction = function() {
                    window.localStorage.setItem(bigstockMessageUnderstood, JSON.stringify(true));
                    premiumDialog.closeDialog();
                };
                premiumDialog.showInitialDialog(btnAction, maxNumberOfImages);
            }
        }
    };

    return angular.extend(source, {
        getName: getName,
        getSectionModel: getSectionModel,
        getItemsProvider: getItemsProvider,
        isAvailable: isAvailable,
        getToolbarItems: getToolbarItems,
        beforeInsert: beforeInsert,
        canAddToInsert: canAddToInsert,
        itemRemovedFromInsert: itemRemovedFromInsert,
        beforeSubsectionShow: beforeSubsectionShow
    });
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/sources/diyfmsourcebigstock.js
 ** module id = 950
 ** module chunks = 0
 **/